<template>
    <simple-activity :show-header="false">
  <div class="app-container" style="display: flex; flex-direction: column;">
    <header-row class="align-items-center header">
      <div class="header-buttons">
        <button class="header-icon-button bg-light rounded border" @click="toggleSearchBar">
          <font-awesome-icon :icon="['far', 'magnifying-glass']" />
        </button>
        <button class="header-icon-button bg-light rounded border" @click="navigateToConfiguration">
          <font-awesome-icon :icon="['far', 'wrench']" />
        </button>
      </div>
    </header-row>
    <div class="flex m-3 align-items-center" v-if="searchBar">
      <div class="flex align-items-center border w-50 rounded">
        <span class="p-2">
          <font-awesome-icon :icon="['far', 'magnifying-glass']" />
        </span>
        <input v-model="searchQuery" :placeholder="$tr('reports.search','Search reports')" class="m-0 p-2 border-0 h6" style="flex: 1; outline: none;" />
      </div>
    </div>

    <div class="container-fluid p-0" style="flex: 1;">
      <div class="row justify-content-center g-3 m-0">
        <details v-for="(reports, group) in groupedReports" :key="group" class="col-12 mt-3">
          <summary class="bg-light border rounded p-2 cursor-pointer" :data-test-path="group">
            <font-awesome-icon :icon="['fas', 'layer-group']" size="xl" class="mr-2" />
<!--            {{$tr(`reports.${group}`, `${group}`)}}-->
            {{group}}
          </summary>
          <div class="row mt-3">
            <div v-for="report in reports" :key="report.securityId" class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center mt-3" v-if="report.defaultVisible">
              <div class="bg-light card card-element d-flex flex-column justify-content-between" :data-test-path="report.name">
                <div class="icon-container">
                  <font-awesome-icon :icon="['fas', 'file-spreadsheet']" size="2x" />
                </div>
                <div>
<!--                  <p class="card-text">{{$tr(`reports.report${report.securityCode}`, `${report.name}`)}}</p>-->
                  <p class="card-text">{{report.name}}</p>
                </div>
                <div>
                  <button type="button" class="btn btn-primary" @click="downloadReport(report)">
                    <span v-if="!isSmallScreen">Generate</span>
                    <font-awesome-icon v-else :icon="['fas', 'download']" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </details>
      </div>
    </div>
  </div>
    </simple-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms, { setDynamicPermissionsForReports } from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import GridActivity from "@/activity/templates/layouts/GridActivity.vue";
import CloseButton from "@/components/navbar/CloseButton.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import HeaderRow from "@/components/layout/HeaderRow.vue";
import tr from "@/utils/Tr";
import ReportsManager from "@/ReportsManager";
import FormsActions from "@/components/forms/FormsActions";
import CompanyConfigurationFormField from "@/server/com/silkplm/model/plm/CompanyConfigurationFormField";
import ActivityManager from "@/activity/ActivityManager";
import ReportsConfigurationForm from "@/components/plm/ReportsConfigurationForm.vue";
import ComplexActivity from "@/activity/templates/layouts/ComplexActivity.vue";
import ReportFiltersParameters from "@/components/plm/reports/ReportFiltersParameters.vue";

export default {
  name: "Reports",
  components: {ComplexActivity, HeaderRow, FooterNavbar, CloseButton, GridActivity, SimpleActivity, FooterButton },

  methods: {
    ...Activity.methods,

    updateScreenSize() {
      this.isSmallScreen = window.innerWidth <= 768;
    },

    getTitle() {
      return 'Reports';
    },
    async canClose() {
      return await DialogManager.canClose(this.unsavedChanges);
    },

    async downloadReport(report) {
      if(report.reportFilterSpecs.length === 0){
        await ReportsManager.executeReport(report.reportClassName);
      } else {
        await ActivityManager.showActivity(ReportFiltersParameters, {report});
      }
    },

    async navigateToConfiguration() {
      return ActivityManager.showActivity(ReportsConfigurationForm);
    },

    toggleSearchBar() {
      this.searchBar = !this.searchBar;
      if (!this.searchBar) {
        this.searchQuery = '';
      }
    },
  },
  async mounted() {
    window.addEventListener("resize", this.updateScreenSize);
    this.reports = await Rpc.Reports.getReportConfigs();
    setDynamicPermissionsForReports(this.reports);
    this.reports = this.reports.filter(report => {
      let securityCode = report.securityCode;
      return SessionManager.hasPermission(securityCode) || SessionManager.hasPermission(Perms.ALL_REPORT);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
  data() {
    return {
      unsavedChanges: false,
      permissions: new PermissionsSet(),
      showHeader: false,
      reports: [],
      searchQuery: '',
      searchBar: false,
      isSmallScreen: window.innerWidth <= 768
    }
  },
  computed: {
    filteredReports() {
      return this.reports.filter(report => report.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
    },
    groupedReports() {
      const groups = {};
      this.filteredReports.forEach(report => {
        if (!groups[report.nameForReportGroup]) {
          groups[report.nameForReportGroup] = [];
        }
        groups[report.nameForReportGroup].push(report);
      });
      return groups;
    }
  }
}
</script>

<style scoped>
.header {
  height: 40px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: start;
  border-bottom: 1px solid #dee2e6 !important;
}

.header-buttons {
  display: flex;
  align-items: center;
  padding-left: 15px;
}

.header-icon-button {
  padding: 5px 10px;
  font-size: 16px;
}

.card-element {
  width: 200px;
  text-align: center;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 10%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.icon-container {
  background-color: #f0f0f0;
  padding: 40px;
  border-radius: 10%;
  margin-bottom: 20px;
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-text {
  margin-bottom: 10px;
  font-size: 14px;
  color: #5294b3;
}

button {
  margin-top: auto;
}

details {
  width: 100%;
}

summary {
  font-size: 14px;
  color: #5294b3;
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
